import { StyleSheet } from 'react-native';

import Colors from '../../config/Colors';
import Layout from '../../config/Layout';

export default StyleSheet.create({
    button: {
        minWidth: 90,
        minHeight: 44,
        backgroundColor: Colors.secondary,
        paddingHorizontal: Layout.gutter,
        paddingVertical: 8,
        marginTop: 16,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        borderRadius: 6
    },
    buttonBox: {
        flex: 3,
        justifyContent: 'center',
        alignItems: 'center'
    },
    buttonText: {
        fontSize: 18,
        color: Colors.white
    },
    buttonDisabled: {
        backgroundColor: Colors.regular
    }
});
